import { render, staticRenderFns } from "./Structures.vue?vue&type=template&id=3694736a&scoped=true&"
import script from "./Structures.vue?vue&type=script&lang=js&"
export * from "./Structures.vue?vue&type=script&lang=js&"
import style0 from "./Structures.vue?vue&type=style&index=0&id=3694736a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3694736a",
  null
  
)

export default component.exports